import { useMemo } from "react";
import { CourseMaterial, useProgramDetails } from "./coursesLoader.ts";
import {
  ReturnState,
  ShippingState,
} from "common/api/decimal/methods/course.ts";
import useOptedIn from "./useOptedIn.tsx";
import useVirtualStore from "routes/home/common/virtual-store/useVirtualStore.tsx";

export type OrderStatus =
  | "Not Applicable"
  | "Awaiting Order"
  | ReturnState
  | ShippingState;

export default function useOrderInfo(material: CourseMaterial) {
  const isOptedIn = useOptedIn(material);
  const { isVirtualStore } = useVirtualStore();
  const { scope } = useProgramDetails();

  const orderStatus: OrderStatus = useMemo(() => {
    if (
      material.materialFormat !== "print" ||
      !isVirtualStore ||
      scope !== "ea_only"
    ) {
      return "Not Applicable";
    }
    if (!material.orderInfo) {
      if (isOptedIn) {
        return "Awaiting Order";
      } else {
        return "Not Applicable";
      }
    }
    return material.orderInfo?.returnStatus
      ? material.orderInfo?.returnStatus
      : material.orderInfo.shippingStatus;
  }, [material, isOptedIn, isVirtualStore, scope]);

  // Data
  const studentEmail = material?.orderInfo?.studentEmailAddress;
  const address = material?.orderInfo?.address;
  const phone = address?.phone;
  const isCampusAddress = address?.kind === "campus";
  const mapDirectionsUrl = material?.orderInfo?.mapDirectionsUrl;
  const deliveryStatusDate = material?.orderInfo?.deliveryStatusDate;

  return {
    orderStatus,
    returnStatus: material?.orderInfo?.returnStatus,
    shippingStatus: material?.orderInfo?.shippingStatus,
    studentEmail,
    phone,
    address,
    isCampusAddress,
    mapDirectionsUrl,
    deliveryStatusDate,
  };
}
